var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header",
          },
          [_c("span", { staticClass: "card-title" }, [_vm._v("充值记录")])]
        ),
        _c("div", { staticClass: "placeholder-content" }, [
          _c("i", { staticClass: "el-icon-wallet" }),
          _c("p", [_vm._v("充值记录页面开发中...")]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }